import { combineReducers } from "redux";
import registration from "./registration";
import login from "./login";
import validation from "./validation";
import api from "./api";
import auth from "./auth";
import onboarding from "./onboarding";
import changePassword from "./dashboard/changePassword";
import notifications from "./notifications/notifications";
import dashboard from "./dashboard";
import settings from "./settings";

const rootReducer = combineReducers({
  api,
  auth,
  registration,
  login,
  validation,
  onboarding,
  notifications,
  changePassword,
  dashboard,
  settings,
});

//eslint-disable-next-line
export default (state, action) =>
  rootReducer(action.type === "AUTH_LOGOUT" ? undefined : state, action);
